const styles = theme => {
  return {
    buttonProgress: {
      color: "#730303",
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
    wrapper: {
      position: "relative",
      display: "inline-block",
    },
    wrapperFullWidth: {
      width: "100%",
    },
    primaryDisabled: {
      backgroundColor: theme.palette.primary.dark,
    },
    secondaryDisabled: {
      backgroundColor: [theme.palette.secondary.dark, "!important"],
    },
    buttonSizeSmall: {
      minWidth: 30,
      padding: 6,
    },
  }
}

export default styles
